import * as T from './types';

const defaultActiveCard = {
  bin: undefined,
  cardHolder: undefined,
  cardNumber: undefined,
  cvvMaxLength: 4,
  id: undefined,
  issuingNetwork: 'default',
  isPotentiallyValid: false,
  isValid: false,
};

const initialState = {
  activeCard: defaultActiveCard,
  items: [],
  suggests: [],
};

function setRemoveCardStatus(id, cards, isRemoving) {
  const card = cards.find((item) => item.id === id);

  if (card) {
    card.isRemoving = isRemoving;

    return cards;
  }

  return null;
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case T.UPDATE_ACTIVE_CARD: {
      return {
        ...state,
        activeCard: {
          ...defaultActiveCard,
          ...action.activeCard,
        },
      };
    }

    case T.SAVE_CARDS: {
      const { suggests, items } = action;

      return {
        ...state,
        items,
        suggests,
      };
    }

    case T.GET_CARD_SUGGESTS: {
      return {
        ...state,
        suggests: action.suggests,
      };
    }

    case T.RESET_CARD_SUGGEST: {
      return {
        ...state,
        activeCard: defaultActiveCard,
        suggests: state.items,
      };
    }

    case T.REMOVE_CARD: {
      const { id } = action;

      const items = setRemoveCardStatus(id, [...state.items], true);

      if (items) {
        return {
          ...state,
          items,
        };
      }

      return state;
    }

    case T.REMOVE_CARD_SUCCESS: {
      const { id } = action;
      const { currentActiveCard, currentItems } = state;
      let activeCard;

      const items = currentItems.filter((item) => item.id !== id);

      // если удаляем активную карту
      if (currentActiveCard.id === id) {
        const validCards = items.filter((card) => !card.expired);
        activeCard = validCards[0] || defaultActiveCard;
      } else {
        activeCard = currentActiveCard;
      }

      return {
        ...state,
        activeCard,
        items,
        suggests: items,
      };
    }

    case T.REMOVE_CARD_FAIL: {
      const { id } = action;

      const items = setRemoveCardStatus(id, [...state.items], false);

      return {
        ...state,
        items: items || state.items,
        removeCardError: true,
      };
    }

    case T.RESET_REMOVE_CARD_ERROR: {
      return {
        ...state,
        removeCardError: false,
      };
    }

    case T.CLEAR_CARD_LIST: {
      return initialState;
    }

    default:
      return state;
  }
}
